import React, { useEffect, useState } from 'react'
import api from "../../../Axios";
import useLoader from '../../../hooks/useLoader';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import useAuthUser from '../../../hooks/useAuthUser';

const LearningDashboardTab = () => {

  const { loggedInUser } = useAuthUser();
  const userRole = Number(loggedInUser?.role);
  const { hideLoader, showLoader } = useLoader();
  const [dashboardData, setDashboardData] = useState(null)
  const [requestGraph, setRequestGraph] = useState([])
  const [assignmentStatus, setAssigmentStatus] = useState({})

  const fetchDashboardData = async () => {
    showLoader();
    try {
      const res = await api.get(
        '/dashboard/admin/get-dashboard-data'
      )

      setDashboardData(res.data.data);
    } catch (error) {
      console.error('Error fetching dashboard:', error)
    } finally {
      hideLoader();
    }
  }

  const fetchRequestGraph = async () => {
    try {
      const res = await api.get(
        "/dashboard/admin/get-request-data"
      );

      setRequestGraph(res.data.data || []);
    } catch (error) {
      console.error("Error fetching request graph:", error);
    }
  };

  const fetchAssignmentStatusData = async () => {
    try {
      const res = await api.get(
        "/dashboard/admin/get-assignment-status-data"
      );

      setAssigmentStatus(res.data.data || []);
    } catch (error) {
      console.error("Error fetching request graph:", error);
    }
  };

  useEffect(() => {
    fetchDashboardData();
    fetchRequestGraph();
    fetchAssignmentStatusData();
  }, [])

  if (!dashboardData) {
    return;
  }

  return (
    <div className="container-fluid py-4">
      {/* Header */}
      <div className="mb-4">
        <h2 className="fw-bold">Dashboard</h2>
        <p className="text-muted">
          Overview of your learning and development metrics
        </p>
      </div>

      {/* Admin */}
      {([1, 2].includes(userRole)) && <div className="row g-4 mb-4">
        <DashboardCard
          title="Total Category"
          value={dashboardData.totalCategories}
          subtitle="Active learning category"
          bg="bg-primary-subtle"
          icon="bi-book"
        />
        <DashboardCard
          title="Total Internal Programs"
          value={dashboardData.totalPrograms}
          subtitle="Active learning programs"
          bg="bg-primary-subtle"
          icon="bi-book"
        />
        <DashboardCard
          title="Total Employees Assigned On Program"
          value={dashboardData.totalEmployees}
          subtitle="Across all employees"
          bg="bg-warning-subtle"
          icon="bi-people"
        />
        <DashboardCard
          title="Total External Program Cost Raise(₹)"
          value={dashboardData?.totalBudget}
          subtitle={"Across external program"}
          bg="bg-info-subtle"
          icon="bi-graph-up"
        />
      </div>}

      {([7].includes(userRole)) && <div className="row g-4 mb-4">
        <DashboardCard
          title="Total Internal Program Assigned"
          value={dashboardData?.totalAssignedPrograms || 0}
          subtitle="Active learning programs"
          bg="bg-primary-subtle"
          icon="bi-book"
        />
        <DashboardCard
          title="Total External Program Request"
          value={dashboardData?.totalExternalRequests || 0}
          subtitle="External learning programs"
          bg="bg-primary-subtle"
          icon="bi-book"
        />
        <DashboardCard
          title="Total Internal Completed Program"
          value={dashboardData?.completedPrograms || 0}
          subtitle="Across all program"
          bg="bg-warning-subtle"
          icon="bi-people"
        />
        <DashboardCard
          title="Total Internal Progress Program"
          value={dashboardData?.inProgressPrograms}
          subtitle={"Across all program"}
          bg="bg-info-subtle"
          icon="bi-graph-up"
        />
      </div>}

      {/* {([1].includes(userRole)) && <div className="row g-4">
        <div className="col-md-6">
          <div className="card h-100 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Assignment Status</h5>
              <p className="text-muted">
                Current status of all program assignments
              </p>

              <StatusRow
                label="Completed"
                value={assignmentStatus?.completed || 0}
                color="success"
              />
              <StatusRow
                label="In Progress"
                value={assignmentStatus?.in_progress || 0}
                color="primary"
              />
              <StatusRow
                label="Not Started"
                value={assignmentStatus?.not_started || 0}
                color="danger"
              />
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card h-100 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Skill Gap Overview</h5>
              <p className="text-muted">Organization-wide skill gaps</p>

              <h1 className="fw-bold text-primary">
                {dashboardData?.skillGap?.total || 0}
              </h1>
              <p className="mb-1">Total skill gaps identified</p>

              <small className="text-muted">Top gaps by department:</small>
              <div className="d-flex justify-content-between mt-2">
                <span>Engineering</span>
                <span className="fw-bold">
                  {dashboardData?.skillGap?.engineering || 0}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>} */}

      {([1, 2].includes(userRole)) && <div className="row g-4 mt-1">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Monthly External Learning Requests</h5>
              <p className="text-muted">
                Number of external learning requests per month
              </p>

              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={requestGraph}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="month" />
                  <YAxis />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="count"
                    stroke="#0d6efd"
                    strokeWidth={3}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>}
    </div>
  )
}

export default LearningDashboardTab

// Components remain same
const DashboardCard = ({ title, value, subtitle, bg, icon }) => {
  return (
    <div className="col-md-3">
      <div className={`card h-100 shadow-sm ${bg}`}>
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="text-muted">{title}</h6>
            <i className={`bi ${icon} fs-4 text-primary`} />
          </div>
          <h2 className="fw-bold">{value}</h2>
          <div className="text-muted">{subtitle}</div>
        </div>
      </div>
    </div>
  )
}

const ProgressBar = ({ value }) => {
  return (
    <div className="progress" style={{ height: "6px" }}>
      <div
        className="progress-bar bg-primary"
        role="progressbar"
        style={{ width: `${value}%` }}
      />
    </div>
  )
}

const StatusRow = ({ label, value, color }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div>
        <span className={`text-${color} fw-bold me-2`}>●</span>
        {label}
      </div>
      <span className="fw-bold">{value}</span>
    </div>
  )
}